import { useEffect } from 'react'

const CSS_VAR = '--scan-qr-vh'
const BOTTOM_INSET_CSS_VAR = '--scan-qr-browser-bottom-inset'

function syncScanQrViewportHeight() {
  const viewport = window.visualViewport
  const height = viewport?.height ?? window.innerHeight
  const bottomInset = viewport
    ? Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop)
    : 0

  document.documentElement.style.setProperty(CSS_VAR, `${height}px`)
  document.documentElement.style.setProperty(
    BOTTOM_INSET_CSS_VAR,
    `${bottomInset}px`
  )
}

/** Keeps fullscreen scan dialog within the visible viewport on mobile browsers. */
export function useScanQrViewportHeight(active: boolean) {
  useEffect(() => {
    if (!active) {
      document.documentElement.style.removeProperty(CSS_VAR)
      document.documentElement.style.removeProperty(BOTTOM_INSET_CSS_VAR)
      return
    }

    syncScanQrViewportHeight()

    const viewport = window.visualViewport
    viewport?.addEventListener('resize', syncScanQrViewportHeight)
    viewport?.addEventListener('scroll', syncScanQrViewportHeight)
    window.addEventListener('resize', syncScanQrViewportHeight)
    window.addEventListener('orientationchange', syncScanQrViewportHeight)

    return () => {
      viewport?.removeEventListener('resize', syncScanQrViewportHeight)
      viewport?.removeEventListener('scroll', syncScanQrViewportHeight)
      window.removeEventListener('resize', syncScanQrViewportHeight)
      window.removeEventListener('orientationchange', syncScanQrViewportHeight)
      document.documentElement.style.removeProperty(CSS_VAR)
      document.documentElement.style.removeProperty(BOTTOM_INSET_CSS_VAR)
    }
  }, [active])
}
